<template>
<div v-if="show" class="error-pop animated fadeIn">
<table>
  <tr>
    <td class="alertIcon">
      <i class="fas fa-exclamation-circle" />
    </td>
    <td class="text">
      We will perform system maintenance and upgrade from March 21 (Saturday), 2:00 p.m. to March 22 (Sunday) 11:59 p.m. In that period. Please contact us if you need any assistance
</td>
    <td class="closePop">
      <i @click="hide" class="fas fa-times" />
    </td>
  </tr>
</table>
  <div class="closePopMobile">
    <i @click="hide" class="fas fa-times" />
  </div>
</div>
</template>

<script>
export default {
  name: 'ErrorPopVue',
  data: function() {
    return {
      show: false
    }
  },
  mounted() {
    const cookie = this.$cpCookie.get('hideError')
    const current = new Date().getTime()
    const start = 1584234000000 // new Date('2020-03-15 9:00').getTime()
    const end = 1584892800000 // new Date('2020-03-23 00:00').getTime()

    if (cookie !== 1) {
      if (current >= start && current <= end) {
        this.show = true // Show
      }
    }
  },
  methods: {
    hide: function() {
      this.show = false
      this.$cpCookie.set('hideError', '1')
    }
  }
}
</script>
